import { api } from '../../../api/Middleware';

const API_URL = process.env.REACT_APP_API_URL;
const BASE = `${API_URL}agents_flow/agents`;

const InstagramApiService = {
  /**
   * Lista TODAS as contas IG ativas da account do usuário (account-level).
   * Usado pelo UserContext para popular bottyData com contas IG.
   */
  listAccounts() {
    return api.get(`${API_URL}agents_flow/agents/instagram-accounts/`);
  },

  /**
   * Inicia OAuth Login Instagram. Backend retorna `authorize_url` que
   * o front abre em popup. Após autorizar, callback envia postMessage.
   */
  oauthStart(agentId) {
    return api.get(`${BASE}/${agentId}/instagram/oauth-start/`);
  },

  /**
   * Finaliza OAuth quando o usuário tem múltiplas Pages com IG Business
   * e precisou escolher uma. selectionKey vem no postMessage de erro
   * com `needs_page_selection=true`.
   */
  selectPage(agentId, selectionKey, pageId) {
    return api.post(`${BASE}/${agentId}/instagram/oauth-select-page/`, {
      selection_key: selectionKey,
      page_id: pageId,
    });
  },

  /**
   * Status atual da conta IG vinculada (ou {connected: false}).
   */
  getStatus(agentId) {
    return api.get(`${BASE}/${agentId}/instagram/`);
  },

  /**
   * Atualiza bot_paused ou solicita refresh de profile.
   */
  update(agentId, data) {
    return api.patch(`${BASE}/${agentId}/instagram/`, data);
  },

  /**
   * Desconecta a conta IG (unsubscribe webhook + is_active=False).
   */
  disconnect(agentId) {
    return api.delete(`${BASE}/${agentId}/instagram/disconnect/`);
  },
};

export default InstagramApiService;
